import React, { memo } from "react";
import Typography from "@mui/material/Typography";
import Choices from "../Choices";
import ReusableAccordian from "../ReusableAccordion";
import { Image } from "cloudinary-react";
import SillFinish from "../SillFinish/SillFinish";
import { SillColor } from "../Sill/SillAccordian";
import { raisedSills } from "../Sill/defaults";
import { RowLayout, ColLayout } from "../../util/accordianStyles";
import { styled } from "@mui/material/styles";
import useSillSelector from "./useSillSelector";
import { addScrollElements } from "../AccordionWrapper/AccordianWrapper";

const RowLayoutSpacing = styled("div")(({ theme }) => ({
  marginBottom: 10,
  alignItems: "center",
  justifyContent: "center",
  display: "flex",
  padding: theme.spacing(1, 2),
  alignSelf: "flex-end",
  marginTop: 60,
}));

const ColLayoutSpacing = styled("div")(({ theme }) => ({
  marginBottom: 10,
  marginTop: 20,
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  padding: theme.spacing(1, 2),
}));

function FPSillAccordian() {
  const {
    fixedPanelSill,
    handleClick,
    showSillFinish,
    sillStyle,
    exactConfig,
    sillColorChoice,
  } = useSillSelector();

  return (
    <>
      {addScrollElements(["Sill Finish", "Sill Dam Finish", "Sill Type"])}

      <ReusableAccordian
        accordionName="sill"
        heading="Sill Choice"
        secondaryHeading="Select sill choice"
        colOrRow="col"
      >
        {exactConfig !== "Fixed Bi-fold" ? (
          <RowLayout>
            <RowLayoutSpacing>
              <Image
                cloudName="ag-millworks"
                secure="true"
                publicId={`Sills/fixedPanels${fixedPanelSill?.img}`}
                style={{ paddingRight: 40 }}
              />

              <Choices
                wide={true}
                label={fixedPanelSill?.label || ""}
                variant="filled"
                checkMark={true}
                disabled={true}
              />
            </RowLayoutSpacing>

            <SillColor
              handleClick={handleClick}
              sillColorChoice={sillColorChoice || ""}
            />

            {showSillFinish && <SillFinish />}
          </RowLayout>
        ) : (
          <ColLayout>
            <RowLayout>
              <ColLayoutSpacing>
                <Typography style={{ margin: "auto" }} variant="subtitle1">
                  Sill Types
                  <span style={{ color: "red", fontSize: 20 }}>*</span>
                </Typography>
                <RowLayout>
                  <Choices
                    label="Raised Sill"
                    variant="filled"
                    checkMark
                    disabled
                  />
                </RowLayout>

                <RowLayout>
                  {raisedSills.map((state) => (
                    <div
                      key={state.id}
                      onClick={() => handleClick(state.label, state.type)}
                    >
                      <Choices
                        label={state.label}
                        variant={
                          state.label === sillStyle ? "filled" : "outlined"
                        }
                        checkMark={state.label === sillStyle}
                        disabled={false}
                      />
                    </div>
                  ))}
                </RowLayout>
              </ColLayoutSpacing>

              <SillColor
                handleClick={handleClick}
                sillColorChoice={sillColorChoice || ""}
              />

              {showSillFinish && <SillFinish />}
            </RowLayout>

            {sillStyle && (
              <RowLayout>
                <div>
                  <Image
                    cloudName="ag-millworks"
                    secure="true"
                    publicId={
                      sillStyle === "Rounded Dam"
                        ? "v1692741946/Sills/fixedPanels/bifold_round.jpg"
                        : "v1692741946/Sills/fixedPanels/bifold_square.jpg"
                    }
                  />
                </div>
              </RowLayout>
            )}
          </ColLayout>
        )}
      </ReusableAccordian>
    </>
  );
}

export default memo(FPSillAccordian);
